import { useEffect, useRef } from 'react';

/**
 * Runs fetchFn whenever deps change (pagination, filters, search).
 * Prefer over hasFetched refs — those skip refetches and fight Strict Mode.
 */
export function useListFetch(fetchFn, deps) {
    const fetchRef = useRef(fetchFn);
    fetchRef.current = fetchFn;

    useEffect(() => {
        fetchRef.current();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, deps);
}
